import { z } from 'zod';
import { OrderDirection } from '@/constants/orderDirection';
export const GroupIdLedgerSortColumns = {
  LOGIN_ID: 'loginId',
  GROUP_NAME: 'name'
} as const;
export const GroupIdLedgerTableFilterSchema = z.object({
  page: z.number().int().min(1).optional().default(1),
  pageSize: z.number().default(100),
  freeText: z.string().optional(),
  sortOrder: z.nativeEnum(OrderDirection).default(OrderDirection.ASC).optional(),
  sortColumn: z.enum([GroupIdLedgerSortColumns.LOGIN_ID, GroupIdLedgerSortColumns.GROUP_NAME]).default(GroupIdLedgerSortColumns.LOGIN_ID).optional()
});